import get from 'lodash/get';

import { AppRootState } from '../../../../../store/models/app-state.model';
import { APPS, APPS_FEATURE } from '../../../../../store/utils/files-names';
import { AppsHeaderAndPaginationFilters } from '../../../models/apps-header-and-pagination-filters.model';

export const getAppsTableFiltersSelector = (
  state: AppRootState
): AppsHeaderAndPaginationFilters =>
  get(state, `${APPS_FEATURE}.${APPS}`).filters;
